import { Component, ViewChild } from '@angular/core';
import { NavController, LoadingController, ModalController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { HttpParams, HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { SelectBetweenDatetime } from '../../components/popups/select-between-datetime/select-between-datetime';
import * as moment from 'moment';

@Component({
  selector: 'page-configuration-advanced-logs',
  templateUrl: 'configuration-advanced-logs.html'
})

export class ConfigurationAdvancedLogsPage {

  list: any;
  load_logs: boolean = false;
  date_first: any;
  date_last: any;
  ticket_timeline: any;
  logs_array_filtered: any;
  logs_searchbar_text: string = '';
  //datatable
  sorts = [
    { prop: 'date', dir: 'asc' },
    { prop: 'type', dir: 'asc' },
    { prop: 'movement', dir: 'asc' },
    { prop: 'waiter', dir: 'asc' },
    { prop: 'app_section', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public globals: Globals,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    public translate: TranslateService,
    public modalCtrl: ModalController) {

    //init dates
    this.date_first = moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss');
    this.date_last = moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
    this.getLogs();
  }

  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('general-tickets-pagados'),
      date_first: this.date_first,
      date_last: this.date_last,
      cash_bool: false,

    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.date_first = data.date_first;
        this.date_last = data.date_last;
        //
        this.getLogs();
      }
    });
    profileModal.present();
  }


  async getLogs() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('date_first', moment(this.date_first).format('YYYY-MM-DD HH:mm:ss'))
      .set('date_last', moment(this.date_last).format('YYYY-MM-DD HH:mm:ss'));
    await this.http.post(this.globals.analytics_path + 'get_logs_tickets_timeline', params, {})
      .subscribe(async res => {
        this.ticket_timeline = res;
        this.logs_array_filtered = this.ticket_timeline;
        // Si hay texto en el buscador, aplicamos el filtro
        if (this.logs_searchbar_text) {
          this.logsSearch(this.logs_searchbar_text);
        }
      });
  }

  getSectionType(value) {
    var _return = '';
    value = value.split(' - ');
    switch (value[0].toLowerCase()) {
      case 'tpv':
        _return = this.translate.instant('general-tpv');
        if (value[1]) {
          _return += ' - ' + value[1];
        }
        break;
      case 'orders':
        _return = this.translate.instant('general-comandero');
        if (value[1]) {
          _return += ' - ' + value[1];
        }
        break;
      case 'takeaway':
        _return = this.translate.instant('general-takeaway');
        if (value[1]) {
          _return += ' - ' + value[1];
        }
        break;
      case 'mct pay':
        _return = this.translate.instant('general-mycheftool') + ' Pay';
        break;
      default:
        _return = value;
    }
    return _return;
  }

  getMovementText(value, type) {
    var _return = '';
    if (type.includes('pay')) {
      _return = parseFloat(value).toFixed(2) + this.globals.currency_symbol
    } else {
      switch (type) {
        case 'print ticket':
          _return = 'Nº ' + value;
          break;
        case 'refund ticket':
          _return = 'Nº ' + value;
          break;
        case 'refund ticket':
          _return = 'Nº ' + value;
          break;
        case 'create invoice':
          _return = 'Nº ' + value;
          break;
        default:
          _return = value;
      }
    }
    return _return;
  }

  trFontColor(ticket) {
    if (ticket.refund && ticket.amount < 0) {
      let cssClasses = {
        'text-danger': true,
      };
      return cssClasses;
    }
    return '';
  }

  logsSearch(value) {
    if (value) {
      this.logs_array_filtered = this.ticket_timeline.filter(objeto => {
        // Crear una copia del objeto con el TYPE traducido
        const objetoConTipoTraducido = {
          ...objeto,
          TYPE_TRANSLATED: this.globals.getMovementType(objeto.TYPE)
        };
        return this.globals.objectToArray(objetoConTipoTraducido).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            // Comparar como string
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            // Buscar en cada elemento del array
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
    } else {
      this.logs_array_filtered = this.ticket_timeline;
    }
  }

  addSearchTerm(term: string) {
    const translatedTerm = this.translate.instant(term);
    this.logs_searchbar_text = translatedTerm;
    this.logsSearch(translatedTerm);
  }

  onSort(event) {
    var logs_array = this.logs_array_filtered;
    switch (event.column.name) {
      case 'date':
        if (event.newValue == 'asc') {
          logs_array.sort((a, b) => this.globals.timestampToDate(a.DATE_FORMAT).localeCompare(this.globals.timestampToDate(b.DATE_FORMAT)));
        } else {
          logs_array.sort((a, b) => this.globals.timestampToDate(b.DATE_FORMAT).localeCompare(this.globals.timestampToDate(a.DATE_FORMAT)));
        }
        break;
      case 'type':
        if (event.newValue == 'asc') {
          logs_array.sort((a, b) => this.globals.getMovementType(a.TYPE).toLowerCase().localeCompare(this.globals.getMovementType(b.TYPE).toLowerCase()));
        } else {
          logs_array.sort((a, b) => this.globals.getMovementType(b.TYPE).toLowerCase().localeCompare(this.globals.getMovementType(a.TYPE).toLowerCase()));
        }
        break;
      case 'movement':
        if (event.newValue == 'asc') {
          logs_array.sort((a, b) => a.MOVEMENT.toLowerCase().localeCompare(b.MOVEMENT.toLowerCase()));
        } else {
          logs_array.sort((a, b) => b.MOVEMENT.toLowerCase().localeCompare(a.MOVEMENT.toLowerCase()));
        }
        break;
      case 'waiter':
        if (event.newValue == 'asc') {
          logs_array.sort((a, b) => a.WAITER.toLowerCase().localeCompare(b.WAITER.toLowerCase()));
        } else {
          logs_array.sort((a, b) => b.WAITER.toLowerCase().localeCompare(a.WAITER.toLowerCase()));
        }
        break;
      case 'app_section':
        if (event.newValue == 'asc') {
          logs_array.sort((a, b) => a.APP_SECTION.toLowerCase().localeCompare(b.APP_SECTION.toLowerCase()));
        } else {
          logs_array.sort((a, b) => b.APP_SECTION.toLowerCase().localeCompare(a.APP_SECTION.toLowerCase()));
        }
        break;
    }
    this.logs_array_filtered = logs_array;
  }

  parseDate(dateStr: string): number {
    // Asumiendo formato DD/MM/YYYY HH:mm:ss
    if (!dateStr) return 0;
    const [date, time] = dateStr.split(' ');
    const [day, month, year] = date.split('/').map(Number);
    return new Date(`${year}-${month}-${day}T${time}`).getTime();
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-advanced-logs/configuration-advanced-logs.ts